export default class NotRegisteredRouteError extends Error {
  constructor(routeName: string) {
    super(`Not registered route: ${routeName}`)
    this.name = 'NotRegisteredRouteError'
  }
}
